import { useQuery } from '@tanstack/react-query'

import { getMerchantOrgBlockList } from '@src/api'
import { DefaultApiGetMerchantOrgBlockListRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchMerchantOrgBlockList = (
  params: DefaultApiGetMerchantOrgBlockListRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.organizationId,
    queryFn: () => getMerchantOrgBlockList(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_MERCHANT_ORG_BLOCK_LIST,
      params.organizationId,
    ],
  })
}
